import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<PurchaseOrderGoodsIn>({})
export default class PurchaseOrderGoodsIn extends Vue {

  // #region @Props

  @Prop()
  protected purchaseOrderNr!: string;
  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion


  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #endregion

  // #region @Watchers
  // #endregion
}
